// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","button":"button","error":"error","primary":"primary","secondary":"secondary","disabled":"disabled","CondolenceItem":"CondolenceItem","rollover":"rollover","postInfo":"postInfo","rememberedBy":"rememberedBy","divider":"divider","name":"name","details":"details","body":"body","icon":"icon","overlay":"overlay","candleFigure":"candleFigure","noMessage":"noMessage","audio":"audio","video":"video","modal":"modal","closeButton":"closeButton","hover":"hover","imageBackground":"imageBackground","candle":"candle","isAd":"isAd","content":"content"};


//////////////////
// WEBPACK FOOTER
// ./src/reactModules/pages/Person/components/GuestBook/css/CondolenceItem.styl
// module id = 1620
// module chunks = 0